import React, { useState, useEffect } from "react";
import { Grid, Alert } from "@deere/fuel-react";
import CampaignClosedAlert from '../../../components/CampaignClosedAlert';
import LinearProgressIndicator from "../../../components/LineProgressIndicator";
import { useLocation, Redirect } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router";
import { useUserInfo } from "../../../providers/userProvider";
import { getCampaigsByRn } from "../../../services/campaign.service";
import SurveyTitle from "../../../components/SurveyTitle";
import { isValidRequestNumber, validationRules, findAnswerIndex } from "../../../utils/utils";
import SectionPage from "../SectionPage";
import { getResponseByIdSurveypart } from "../../../services/surveypart.service";
import ReviewActions from "./ReviewActions";
import { submitSurveyPartResponse } from "../../../services/surveypart.service";
import { ModalSubmit } from "../../../components/ModalSubmit";
import { SURVEY_RESPONSE_STATUSES, CRS_REQUEST_STATUS_OBJ, ADMIN_SEC_TYPE, SURVEYPART_SECTION_TYPES,SAD_DISCLAIMER_MESSAGE_KEY, DEFAULT_LANGUAGE, AGREEMENT_POSITIONS, DISCLAIMER_MSG_CODE } from "../../../utils/surveyLiterals";
import { ERR_DESC_REQUEST_NUMBER, ERR_TITLE_REQUEST_NUMBER } from "../../../utils/errorLiterals";
import { CMDeereUserSubmitConfirmation } from '../../../components/modals/CMDeereUserSubmitConfirmation';
import { useTranslation } from "react-i18next";
import AgreementPopUp from "../../../components/modals/AgreementPopUp";
import Cookies from "js-cookie";
import { CRS_EXT_TOKEN } from "../../../utils/constants";

export default function ReviewPage() {
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  const { authState } = useOktaAuth();
  const history = useHistory();
  const location = useLocation();
  const [statusSaved, setStatusSaved] = useState(undefined);
  const [survey] = useState(location.state.survey);
  const [assignmentId] = useState(location.state.assignmentId);
  const [responseId] = useState(location.state.responseId);
  const [campaignAssigned, setCampaignAssigned] = useState();
  const [containsError, setContainsError] = useState();
  const [surveyPartResponse, setSurveyPartResponse] = useState();
  const sections = survey.sections.filter((q) => q.active).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1));
  const [showGoToSearchModal, setShowGoToSearchModal] = useState(false);
  const [validationMsg, setValidationMsg] = useState("");
  const [showAgreement, setShowAgreement] = useState(false);
  const [agreementMessage, setAgreementMessage] = useState("");

  let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
  let nonOktaAuthFailed = !isAuthMethodOkta ? (location.state && location.state.isAuthNonOkta ? false : true) : false;
  let token = isAuthMethodOkta ? authState?.accessToken?.accessToken : sessionStorage.getItem(CRS_EXT_TOKEN);
  const literals = location?.state?.literals;
  const disclaimerPosition = location?.state?.disclaimerPosition;
  const currentLanguageCode = Cookies.get('i18next') || DEFAULT_LANGUAGE;

  let sec = sections.find(sec => sec.type === ADMIN_SEC_TYPE)
  let isNewSurveyVersion= !(sec=== undefined)
  useEffect(() => {
    if ((!isAuthMethodOkta || userInfo) && assignmentId && isValidRequestNumber(assignmentId)) {
      getCampaigsByRn(assignmentId, token)
        .then((res) => {
          let errorValidation = isAuthMethodOkta ? validationRules(res, userInfo) : false;
          if (errorValidation) {
            setContainsError(errorValidation);
          } else {
            setCampaignAssigned(res);
          }
        })
        .catch((error) => {
          //Campaign not found
          setContainsError("Campaign was not found,please refresh the page if the error persist contact the support department.");
        });
    }
    if (responseId && assignmentId && campaignAssigned) {
      getResponseByIdSurveypart(responseId, token, campaignAssigned?.isNonDeere, isAuthMethodOkta)
        .then((res) => {
          setSurveyPartResponse(res);
          const resAssignments = res.assignments ? res.assignments : null;
          let supplierList = resAssignments.map(function (tmpAssignment) {
            return tmpAssignment.supplierNumber;
          });
          setValidationMsg("Are you sure you want to delete this response? \n Response No. " + responseId + " \n Supplier(s):" + supplierList.toString());
        })
        .catch((error) => {
          console.log(error);
          setContainsError("Response was not found, please refresh the page if the error persist contact the support department.");
        });
    }
  }, [assignmentId, responseId, userInfo, token]);

  function handlePrint() {
    window.print();
  }

  const submitSurveyFn = () => {
    let adminComment;
    if(isAuthMethodOkta && userInfo.roles.includes(survey.adminRole)){
      let sec = sections.find(sec => sec.type === ADMIN_SEC_TYPE);
      let que=sec?.questions[0];
      let queId = que && que.id ? que.id : null;
      adminComment = {
        questionId: queId,
        answer: adminResponsePopup,
        createdBy: userInfo.userID,
        surveyResponseId: location.state.surveyData.responseId,
      }
    }


    const reqObj = isNewSurveyVersion?{ id: responseId, status: SURVEY_RESPONSE_STATUSES.SUBMITTED, isNonDeere: campaignAssigned.isNonDeere, adminComment: adminComment }
    :
    { id: responseId, status: SURVEY_RESPONSE_STATUSES.SUBMITTED, isNonDeere: campaignAssigned.isNonDeere }
    ;
    submitSurveyPartResponse(reqObj, token, isAuthMethodOkta)
      .then((res) => {
        setStatusSaved({ status: true, message: "Response submitted succesfully", label: "Success:", variant: "success" });
        if (res && res.campaignAssignment && res.campaignAssignment.length > 0 && res.campaignAssignment[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE) {
          setShowGoToSearchModal(true);
        } else {
          history.goBack();
        }
      })
      .catch((error) => {
        console.log(error);
        setStatusSaved({ status: true, message: error && error.message ? error.message : "Error", label: "Error:", variant: "error" });
        window.scrollTo(0, 0);
      });
  };

  if (!isAuthMethodOkta && nonOktaAuthFailed) {
    return (
        <Redirect
            to={{
                pathname: "/error",
                state: { errorTitle: ERR_TITLE_REQUEST_NUMBER, errorDescription: ERR_DESC_REQUEST_NUMBER },
            }}
        />
    );
}

const backToEdit = () =>{
  history.goBack();
}

const handleCloseAgreementPopUp = () => {
  setShowAgreement(false);
};

const showAgreementPopupIfRequired = () => {
  if (disclaimerPosition === AGREEMENT_POSITIONS.SUBMISSION_POPUP || disclaimerPosition === AGREEMENT_POSITIONS.BOTH) {
    let message = literals.find((lt) => lt.code === DISCLAIMER_MSG_CODE && lt.languageCd.split("_")[0] === currentLanguageCode.split("_")[0]);
    if (message && message.text) {
      setAgreementMessage(message.text);
      setShowAgreement(true);
    } else showAdminCommentPopupIfRequired();
  } else showAdminCommentPopupIfRequired();
};

const showAdminCommentPopupIfRequired = () => {
  if (isNewSurveyVersion && isAuthMethodOkta && userInfo.roles.includes(survey.adminRole)) {
    setShowDeereUserConfirmation(true);
  } else submitSurveyFn();
};

  const [showDeereUserConfirmation, setShowDeereUserConfirmation] = useState(false);
  const [adminResponsePopup, setAdminResponsePopup] = useState("");
  const answers = Array.isArray(location.state.surveyData?.answers) ? location.state.surveyData.answers : [];
  let adminSection=sections.find((sec)=>sec.type===SURVEYPART_SECTION_TYPES.ADMIN_COMMENTS)
  let que=adminSection?.questions[0];
  let queId = que && que.id ? que.id : null;
  let index=findAnswerIndex(queId, answers)
  let adminAnswer= answers[index]?.answer;
  return campaignAssigned ? (
    <Grid container>
      <Grid item xs={12} marginBottom={5}>
        <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={surveyPartResponse} handlePrint={handlePrint} endDate={campaignAssigned.endDate} />
      </Grid>
      <Grid item xs={12}>
        {statusSaved && statusSaved.status && (
          <Alert variant={statusSaved.variant} title={statusSaved.label}>
            {statusSaved.message}
          </Alert>
        )}
        {containsError && (
          <Alert variant={"error"} title={"Error"}>
            {containsError}
          </Alert>
        )}
        <CampaignClosedAlert campaign={campaignAssigned} />
        {sections
          .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
          .filter((sec)=>((sec.type!==SURVEYPART_SECTION_TYPES.ADMIN_COMMENTS) || (sec.type===SURVEYPART_SECTION_TYPES.ADMIN_COMMENTS&&adminAnswer)))
          .map((section) => (
            <SectionPage key={`section-${section.id}`} review={true} section={section} survey={survey} surveyData={{ ...location.state.surveyData }} campaign={campaignAssigned} isAuthMethodOkta={isAuthMethodOkta} token={token}/>
          ))}
        <ReviewActions campaign={campaignAssigned} showAgreementPopupIfRequired={showAgreementPopupIfRequired} survey={survey} token={token} isAuthMethodOkta={isAuthMethodOkta}/>
        <AgreementPopUp handleClose={handleCloseAgreementPopUp} showAgreement={showAgreement} submitResponse={showAdminCommentPopupIfRequired} messageKey={agreementMessage}/>
        <ModalSubmit
          showModal={showGoToSearchModal}
          setShowModal={setShowGoToSearchModal}
          titleKey={"cm_lbl_request_completed_title"}
          messageKey={"cm_lbl_request_completed_message"}
          buttonKey={"btn_OK"}
          doNotNavidate={!isAuthMethodOkta}
        />
        {
          isNewSurveyVersion &&(
            <CMDeereUserSubmitConfirmation
            showModal={showDeereUserConfirmation}
            setShowModal={setShowDeereUserConfirmation}
            labelBtnPrimary={t('btn_review_submit')}
            titleModal={"Confirmation"}
            labelBtnSecondary={t('btn_cancel')}
            handleSubmit={submitSurveyFn}
            adminResponsePopup={adminResponsePopup}
            setAdminResponsePopup={setAdminResponsePopup}
        />
          )
        }

      </Grid>
    </Grid>
  ) : (
    <Grid container>
      <Grid item xs={6} md={12}>
        <LinearProgressIndicator title="Loading" subtitle="This will take a couple of seconds" />
      </Grid>
    </Grid>
  );
}
